"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestUserActivationResult = void 0;
var GuestUserActivationResult;
(function (GuestUserActivationResult) {
    GuestUserActivationResult["successful"] = "successful";
    GuestUserActivationResult["alreadyActivated"] = "alreadyActivated";
    GuestUserActivationResult["tokenInvalid"] = "tokenInvalid";
})(GuestUserActivationResult || (exports.GuestUserActivationResult = GuestUserActivationResult = {}));
//# sourceMappingURL=GuestUserActivationResult.js.map